import { Asset } from '@/api/generatedApi';
import { Box } from '@mui/material';
import { createUseStyles } from '@/services/createUseStyles';
import { SimpleTreeView } from '@mui/x-tree-view';
import { DependencyTreeView, TreeItemWrapper, DependencyContext } from './DependencyTreeView';

const useStyles = createUseStyles({
  DependencyTreeContainer: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
});

export interface DependencyTreeContainerProperties {
  asset: Asset;
  onTreeItemClick?: (itemId: string, context?: DependencyContext) => void;
  highlightedAssetIds?: string[];
  highlightedNodeNames?: string[];
}

export const DependencyTreeContainer = ({
  asset,
  onTreeItemClick,
  highlightedAssetIds,
  highlightedNodeNames,
}: DependencyTreeContainerProperties) => {
  const c = useStyles();

  return (
    <Box data-cy='assembly-tree-wrapper' className={c.DependencyTreeContainer}>
      <SimpleTreeView
        key={asset.id}
        aria-label='assembly tree'
        data-cy='assembly-tree'
        sx={{
          '& > .MuiTreeItem-root > .MuiTreeItem-content.Mui-selected, & > .MuiTreeItem-root > .MuiTreeItem-content.Mui-selected.Mui-focused':
            {
              backgroundColor: 'transparent',
            },
        }}
      >
        <TreeItemWrapper id={asset.id} path={asset.path} hasMissingChildDependencies={asset.isMissingDependencies}>
          <DependencyTreeView
            asset={asset}
            onTreeItemClick={onTreeItemClick}
            highlightedAssetIds={highlightedAssetIds}
            highlightedNodeNames={highlightedNodeNames}
          />
        </TreeItemWrapper>
      </SimpleTreeView>
    </Box>
  );
};
